export interface GlobalErrorState {
  status?: number;
}

export const initialState: GlobalErrorState = {
  status: undefined,
};
